export default __webpack_public_path__ + "static/media/Group9228.03fe3314.svg";